import { api } from '@/lib/api';
import type {
  IApiResponse,
  IPipelineStatusSummary,
  IPipelineLatestStatus,
  IPipelineRunHistoryResponse,
} from '@skystone/shared';

export const pipelineStatusApi = {
  getSummary: async (): Promise<IPipelineStatusSummary> => {
    const result = await api.get<IApiResponse<IPipelineStatusSummary>>('/pipeline-status/summary');
    return result.data;
  },

  getLatestStatus: async (): Promise<IPipelineLatestStatus[]> => {
    const result = await api.get<IApiResponse<IPipelineLatestStatus[]>>('/pipeline-status/latest');
    return result.data;
  },

  getRunHistory: async (filters?: {
    pipelineName?: string;
    status?: string;
    page?: number;
    pageSize?: number;
  }): Promise<IPipelineRunHistoryResponse> => {
    const params = new URLSearchParams();
    if (filters?.pipelineName) params.set('pipelineName', filters.pipelineName);
    if (filters?.status) params.set('status', filters.status);
    if (typeof filters?.page === 'number') params.set('page', String(filters.page));
    if (typeof filters?.pageSize === 'number') params.set('pageSize', String(filters.pageSize));

    const query = params.toString();
    const endpoint = query ? `/pipeline-status/history?${query}` : '/pipeline-status/history';
    const result = await api.get<IApiResponse<IPipelineRunHistoryResponse>>(endpoint);
    return result.data;
  },

  getPipelineNames: async (): Promise<string[]> => {
    const result = await api.get<IApiResponse<string[]>>('/pipeline-status/pipeline-names');
    return result.data;
  },
};
